import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { UmsService } from '../ums.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { ModalpopService } from '../modalpop.service';
import { PdfviewerComponent } from '../pdfviewer/pdfviewer.component';
import { Observable, Subscriber } from 'rxjs';
import { AvailableStatusComponent } from '../available-status/available-status.component';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
  DasboardForm: FormGroup;
  tName: string;
  Session: string;
  Subject: any;
  college: any;
  name: any;
  ShowForTeacher: boolean;
  userType: string; collegeList: any;
  filteredCollegeList: any;
  dialogRef: MatDialogRef<any>;
  UserCollege: string;
  DepartmentList: any[];
  filteredDepartmentList: any[];
  filteredmapSubjectList: any;
  mapSubjectList: any;
  saveButton = true;
  updateButton = false;
  deleteButton: boolean;
  isUgApproval = false;
  isPgApproval = false;
  DesignationList: any;
  filterDesignationList: any;
  GenderList: any;
  filterGenderList: any;
  APIService: any;
  prepopulationId: any;
  LoginIDD: any;
  prepopulationDeleteId: any;
  isreaddelete = false;
  isreadupdate = false;
  errormessage: any;
  filename: any;
  fileName: string;
  uploadDocUG: any;
  uploadDocPG: any;
  uploadDocPhoto: any;
  uploadDocSign: any;
  fileUploadUGData: any;
  fileUploadPGData: any;
  fileUploadPhotoData: any;
  fileUploadSignata: any;
  FileDataPG: boolean;
  FileDataUG: boolean;
  teacherCreate = true;
  teacherUpdate = true;
  teacherDelete = true;
  TstatusList: any;
  filterTstatusList: any;
  fcCodeList: any;
  filteredListFcCode: any;
  userPermission: any;
  theoryExamAppointments: any[] = [];
  showTheoryExamAppointments: boolean = false;
  utp: string;
  showAss: boolean;
  ShowForAvaiReqst: boolean;
  showAddReason: boolean;
  TeacherAvailiData: any;
  AvaiDisabled: boolean;
  AvaiDisabled2: boolean;
  AssigDisabled: boolean;
  AssigDisabled2: boolean;
  TeacherAssignData: any;

  // Master session list — used only to resolve SnNo -> SnName for display
  sessionList: any[] = [];

  readonly PRACTICAL_MARK_ENTRY_ROUTE = '/Practical-Marks';

  constructor(
    public umsService: UmsService,
    private fb: FormBuilder,
    public router: Router,
    private httpClient: HttpClient,
    private route: ActivatedRoute,
    private modalPopupService: ModalpopService,
    private spinner: NgxSpinnerService,
    private dialog: MatDialog,
  ) { }

  ngOnInit(): void {
    sessionStorage.getItem('usertypeee');
    this.Session = sessionStorage.getItem('session');
    sessionStorage.getItem('userId');

    this.DasboardForm = this.fb.group({
      reqAcceptence: new FormControl(''),
      FcCode: new FormControl(''),
      TeacherStatus: new FormControl(''),
    });

    // Load session master list first so we can resolve SnNo -> SnName
    this.fetchSessionList();

    this.getUserData(sessionStorage.getItem('userId'));
  }

  getUserData(id) {
    this.umsService.getUserData(id).subscribe((res) => {
      this.tName = res.data[0][0].LoginName;
      this.fetchSecretData();

      if (res.data[0][0].LoginLevel == 11) {
        this.userType = 'Super Admin';
      } else if (res.data[0][0].LoginLevel == 10) {
        this.userType = 'Admin';
      } else if (res.data[0][0].LoginLevel == 6) {
        this.userType = 'User';
      } else if (res.data[0][0].LoginLevel == 1) {
        this.userType = 'Teacher';
        this.fetchTheoryExamAppointments();
      } else {
        this.userType = 'Student';
      }

      if (this.userType == 'Teacher') {
        this.ShowForTeacher = true;
      } else {
        this.ShowForTeacher = false;
      }
    });
  }

  fetchSessionList() {
    const payload = {};
    payload['SnDefault'] = '';
    payload['SnNo'] = '';
    this.umsService.getSession(payload).subscribe({
      next: (res: any) => {
        this.sessionList = (res && res.status && res.data) ? res.data : [];
      },
      error: (err) => {
        console.error('Failed to fetch session list', err);
        this.sessionList = [];
      }
    });
  }
  
  getSessionName(tdata: any): string {
    if (tdata) {
      const rowName = tdata.SnName || tdata.SessionName || tdata.SessionDesc;
      if (rowName) return rowName;
    }

    const rowSessionId = tdata
      ? (tdata.SnNo || tdata.SessionId || tdata.Session || tdata.SessionNo)
      : null;
    const lookupId = rowSessionId || this.Session;

    if (lookupId && this.sessionList && this.sessionList.length > 0) {
      const found = this.sessionList.find(
        (s: any) => String(s.SnNo) === String(lookupId)
      );
      if (found) return found.SnName || String(lookupId);
    }

    if (lookupId) return String(lookupId);
    return '-';
  }

  fetchTheoryExamAppointments() {
    const payload = { MobileNo: this.tName };
    this.umsService.getTeacherIdByMobile(payload).subscribe({
      next: (res: any) => {
        if (res.status && res.data && res.data.length > 0) {
          const techId = res.data[0].TechId;
          const appointmentPayload = {
            TechId: parseInt(techId),
            SessionId: this.Session ? parseInt(this.Session) : null
          };
          this.umsService.getTeacherAppointmentsForDashboard(appointmentPayload).subscribe({
            next: (appRes: any) => {
              if (appRes.status && appRes.data && appRes.data.length > 0) {
                this.theoryExamAppointments = appRes.data;
                this.showTheoryExamAppointments = true;
              } else {
                this.showTheoryExamAppointments = false;
              }
            },
            error: (err) => console.error(err)
          });
        } else {
          console.warn('Teacher TechId not found for mobile:', this.tName);
        }
      },
      error: (err) => console.error(err)
    });
  }

  viewAppointmentLetter(appointment: any) {
    const role = appointment.RoleCode;
    const isCO = role === 'CO';
    const isCI = role === 'CI';
    const isINV = role === 'INV';
    const isCustodian = role === 'C';

    let reportType: string;
    let payload: any = {
      LoginId: parseInt(sessionStorage.getItem('userId')) || 0,
    };

    if (isCO) {
      reportType = 'CO_LETTER';
      payload.AppointmentId = appointment.AppointmentId;
      payload.Extra1 = JSON.stringify({
        AppointmentId: appointment.AppointmentId,
        InCode: 1
      });
    } else if (isCI) {
      reportType = 'CI_LETTER';
      payload.AppointmentId = appointment.AppointmentId;
      payload.Extra1 = JSON.stringify({
        AppointmentId: appointment.AppointmentId,
        InCode: 2
      });
    } else if (isINV) {
      reportType = 'CI_LETTER';
      const centerCode = appointment.AptCent || appointment.CenterCode;
      const sessionId = appointment.SnNo || appointment.SessionId || this.Session;

      if (!centerCode || !sessionId) {
        this.spinner.hide();
        this.modalPopupService.openPopup(AlertBoxComponent, {
          message: 'Missing center or session information for this appointment.',
          title: 'Error',
          icon: 'fas fa-exclamation-triangle'
        });
        return;
      }
      payload.CenterCode = centerCode;
      payload.SessionId = parseInt(sessionId);
      payload.Extra1 = JSON.stringify({
        AppointmentId: 0,
        InCode: 2
      });
    } else if (isCustodian) {
      reportType = 'C_LETTER';
      payload.AppointmentId = appointment.AppointmentId;
      payload.Extra1 = JSON.stringify({
        AppointmentId: appointment.AppointmentId,
        InCode: 4
      });
    } else {
      this.spinner.hide();
      this.Print(appointment);
      return;
    }

    payload.ReportType = reportType;

    this.spinner.show();
    this.umsService.renderHbsReport(payload).subscribe({
      next: (blob: Blob) => {
        this.spinner.hide();
        const fileURL = URL.createObjectURL(blob);
        window.location.href = fileURL;
      },
      error: (err) => {
        this.spinner.hide();
        console.error('Error:', err);
        this.modalPopupService.openPopup(AlertBoxComponent, {
          message: 'Failed to generate appointment letter',
          title: 'Error',
          icon: 'fas fa-exclamation-triangle'
        });
      }
    });
  }

  fetchSecretData() {
    this.umsService.getSecretData().subscribe((res) => {
      this.Session = res.projectPharam['SnNo'];
      this.gwtTeacherInfo(this.Session);
    });
  }

  gwtTeacherInfo(Session) {
    const payload = {};
    payload['MobileNo'] = this.tName;
    payload['SessionId'] = Session;
    this.umsService.getTeacherPerticular(payload).subscribe(res => {
      this.getTeacherAvailableInfo(Session, res.data[0].TechId);
      if (res.status) {
        this.TeacherAssignData = res.data;
        this.name = res.data[0].Initial + '. ' + res.data[0].FirstName + ' ' + res.data[0].MiddleName + ' ' + res.data[0].LastName;
        this.Subject = res.data[0].EsName;
        this.college = res.data[0].CgName;

        if ((this.Subject == '' || this.Subject == null || this.Subject == undefined) ||
          (res.data[0].PublishStatus == false || res.data[0].PublishStatus == null)) {
          this.showAss = false;
        } else {
          this.showAss = true;
        }

        if (res.data[0].AcceptStatus == 1) {
          this.AssigDisabled = true;
          this.AssigDisabled2 = false;
        } else if (res.data[0].AcceptStatus == 0 || res.data[0].AcceptStatus == -1) {
          this.AssigDisabled = false;
          this.AssigDisabled2 = true;
        } else if (res.data[0].AcceptStatus == 2) {
          this.AssigDisabled = true;
          this.AssigDisabled2 = false;
        }
      }
    });
  }

  getTeacherAvailableInfo(Session, teachId) {
    const payload = {};
    payload['IEATechId'] = teachId;
    payload['SessionId'] = Session;
    this.umsService.getTeacherAvailablity(payload).subscribe(res => {
      if (res.status) {
        this.ShowForAvaiReqst = true;
        this.TeacherAvailiData = res.data;

        if (res.data[0].Availability == 1) {
          this.AvaiDisabled = true;
          this.AvaiDisabled2 = false;
        } else if (res.data[0].Availability == 0 || res.data[0].Availability == -1) {
          this.AvaiDisabled = false;
          this.AvaiDisabled2 = true;
        }
      } else {
        this.ShowForAvaiReqst = false;
      }
    });
  }

  reqAcceptenceClick(value) {
    if (value == 2) {
      this.showAddReason = true;
    } else {
      this.showAddReason = false;
    }
  }

  submitStatus(tdata, type) {
    const dialogRef = this.dialog.open(AvailableStatusComponent, {
      width: 'auto',
      data: { selected: tdata, type },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }

  Print(data) {
    const submitpayload = {};
    submitpayload['TechId'] = data.TechId;
    submitpayload['Designation'] = data.TeacherDesignation;
    submitpayload['CgCode'] = data.AssignedCollegeCode;
    submitpayload['Session'] = data.SessionId;
    submitpayload['SubId'] = data.SubId;

    let jsonString = JSON.stringify(submitpayload);

    const filter = {
      "LoginId": parseInt(sessionStorage.getItem('userId')) ? parseInt(sessionStorage.getItem('userId')) : 0,
      "RptCode": 323,
      "InstName": '',
      "InstNo": this.umsService.secretdata['ClubPartTrans'] ? this.umsService.secretdata['ClubPartTrans'] : 0,
      "ShId": '',
      "CgCode": data.AssignedCollegeCode,
      "RollNo": '',
      "Cent": '',
      "TnCode": '',
      "EsId": '',
      "CsNo": '',
      "PgBreak": '',
      "StrId": '',
      "StrCode": '',
      "RgNo": '',
      "UC": '',
      "Ledger": '',
      "RegnRoll": '',
      "DsCode": '',
      "CoCode": '',
      "SnNo": '',
      "Extra1": jsonString,
    };

    var payload: any;
    payload = filter;
    this.umsService.setData(JSON.stringify(payload));
    this.dialog.closeAll();
    this.redirect('hbsreports');
  }

  redirect(to): void {
    this.router.navigate([to]);
  }

  canShowPracMarkEntry(tdata: any): boolean {
    if (!tdata) return false;

    const pracFlag = String(tdata.PracMarkEntry) === '1';
    const designation = (tdata.TeacherDesignation || '').toString().trim().toUpperCase();
    const isCP = designation === 'CP';
    const accepted = tdata.AcceptStatus === 1;

    return pracFlag && isCP && accepted;
  }

  goToPracticalMarkEntry(tdata: any) {
    if (!tdata) return;

    console.log('Row data:', tdata);
    console.log('CoCode/CourseCode:', tdata.CoCode, tdata.CourseCode);
    console.log('CoName/CourseName:', tdata.CoName, tdata.CourseName);
    console.log('Batch fields:', tdata.BatchName, tdata.PbdBatchName, tdata.AssignedBatch);

    const queryParams: any = {
      SessionId: tdata.SessionId || tdata.SnNo || this.Session || '',
      CoCode:    tdata.CoCode    || tdata.CourseCode    || '',
      CoName:    tdata.CoName    || tdata.CourseName    || '',
      CgCode:    tdata.AssignedCollegeCode || tdata.CgCode || tdata.CollegeCode || '',
      EmId:      tdata.EmId      || tdata.ExamId        || '',
      EsId:      tdata.SubId     || tdata.EsId          || tdata.EsPSubId || '',
      StrId:     tdata.StrId     || tdata.EsStrId       || '',
      BatchName: tdata.BatchName || tdata.PbdBatchName  || tdata.AssignedBatch || ''
    };

    Object.keys(queryParams).forEach(k => {
      if (queryParams[k] === '' || queryParams[k] == null) delete queryParams[k];
    });

    console.log('Navigating with params:', queryParams);

    this.router.navigate([this.PRACTICAL_MARK_ENTRY_ROUTE], { queryParams })
      .catch(err => console.error('Navigation failed:', err));
  }
  get showDateColumns(): boolean {
    return this.theoryExamAppointments?.some(x => x.RoleCode !== 'C') ?? false;
}
}